// Pantalla donde el usuario define su nueva contraseña.
//
// Se llega acá desde el link del mail, que trae el token en el
// fragmento de la URL. Ese token vale una sola vez y vence rápido.

import { useState } from "react";
import * as api from "./api";
import { t, tError, useIdioma } from "./i18n";

export default function Reset({ token, onListo }) {
  useIdioma();
  const [password, setPassword] = useState("");
  const [repetida, setRepetida] = useState("");
  const [error, setError] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [listo, setListo] = useState(false);

  async function enviar(e) {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError(t("reset.passwordCorta", "La contraseña tiene que tener al menos 8 caracteres"));
      return;
    }

    if (password !== repetida) {
      setError(t("reset.noCoinciden", "Las dos contraseñas no coinciden"));
      return;
    }

    setOcupado(true);

    try {
      await api.cambiarPassword(password, token);
      setListo(true);
    } catch (err) {
      setError(tError(err));
    } finally {
      setOcupado(false);
    }
  }

  if (listo) {
    return (
      <div className="login-fondo">
        <div className="login-caja">
          <p className="login-marca">
            <img src="/logo-brujel.png" alt="Brujel" width="640" height="348" />
          </p>
          <h1 className="login-titulo">{t("reset.listoTitulo", "Listo")}</h1>
          <div className="mensaje-ok">
            {t("reset.listoTexto", "Tu contraseña quedó cambiada. Ya puedes entrar con la nueva.")}
          </div>
          <button className="boton-primario" onClick={onListo}>
            {t("reset.irLogin", "Ir al login")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-fondo">
      <form className="login-caja" onSubmit={enviar}>
        <p className="login-marca">
          <img src="/logo-brujel.png" alt="Brujel" width="640" height="348" />
        </p>
        <h1 className="login-titulo">{t("reset.titulo", "Nueva contraseña")}</h1>
        <p className="login-subtitulo">{t("reset.subtitulo", "Elige una contraseña para tu cuenta")}</p>

        {error && <div className="mensaje-error" role="alert">{error}</div>}

        <label className="campo">
          <span>{t("reset.passwordNueva", "Contraseña nueva")}</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("reset.minimo8", "Mínimo 8 caracteres")}
            autoComplete="new-password"
            disabled={ocupado}
            required
          />
        </label>

        <label className="campo">
          <span>{t("reset.repetirla", "Repítela")}</span>
          <input
            type="password"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
            placeholder={t("reset.mismaOtraVez", "La misma otra vez")}
            autoComplete="new-password"
            disabled={ocupado}
            required
          />
        </label>

        <button className="boton-primario" type="submit" disabled={ocupado}>
          {ocupado
            ? t("reset.guardando", "Guardando...")
            : t("reset.cambiar", "Cambiar contraseña")}
        </button>

        <button
          className="boton-texto"
          type="button"
          onClick={onListo}
          disabled={ocupado}
        >
          {t("reset.cancelar", "Cancelar")}
        </button>
      </form>
    </div>
  );
}
